module.exports = __webpack_public_path__ + "img/wenhua.8b3f67ad.png";